import { Link, Stack, Typography } from "@mui/material";
import useLocales from "src/hooks/useLocales";

// ----------------------------------------------------------------------

export const CardHeader = () => {
	const { translate } = useLocales();

	return (
		<Stack gap={0.5}>
			<Typography variant={"h6"}>{translate("app_secrets.scopes_title")}</Typography>
			<Typography variant='body2' color='text.secondary'>
				{translate("app_secrets.scopes_des")}
				<Link
					href={"https://docs.vumi.io/api-resources/authentication/api-login#session-scopes"}
					rel='noopener'
					color={"primary.main"}
					sx={{
						"&:hover": {
							textDecoration: "underline"
						}
					}}
					target='_blank'
					underline='none'
				>
					{translate("app_secrets.scopes_des_1")}
				</Link>
				{translate("app_secrets.scopes_des_2")}
			</Typography>
		</Stack>
	);
};

export default CardHeader;
